module.exports = __webpack_public_path__ + "img/card4-bl4.c389282d.svg";